<div  class="main-banner">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="banner-content text-center">
                            <h1>🚦 Starte jetzt deinen Weg zum Führerschein!</h1>
                            <p>
                                Keine langen Wartezeiten, moderne Fahrzeuge, top Fahrlehrer – <strong>Tommys Fahrschule</strong> bringt dich schnell und sicher ans Ziel.
                                Theorie in nur 7 Tagen. Praxis mit Plan. Du willst mobil sein? Wir machen’s möglich!
                            </p>

                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="banner-image">
                            <img src="assets/img/mobile2.png" class="rounded" alt="image">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="ferienkurs-highlight">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="ferienkurs-box text-center">
                    <span class="badge">🔥 Ferienkurs</span>
                    <h2>Intensiv-Theoriekurs in den Winterferien</h2>
                    <p>
                        <strong>📅 02.01. – 09.01.2026</strong><br>
                        ⏰ Täglich von <strong>10:00 bis 13:15 Uhr</strong>
                    </p>
                    <p class="small">
                        Theorie kompakt in nur 7 Tagen – perfekt für Schüler & Berufstätige.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="fun-facts-area pt-100 pb-70">
    <app-funfacts></app-funfacts>
</section>
<section id="about">
    <section class="about-area pb-100">
        <app-about></app-about>
    </section>
    <section class="features-area pb-70">
        <app-features></app-features>
    </section>
    <section class="testimonials-area ptb-100">
        <app-testimonials></app-testimonials>
    </section>
</section>
<section id="klassen" class="team-area pt-100 pb-70">
    <app-klassen></app-klassen>
</section>
<section id="team" class="team-area pt-100 pb-70">
    <app-team></app-team>
</section>

<section id="kurse" class="ptb-100 container">
    <app-course></app-course>
</section>


<section id="preise" class="pricing-area pt-100 pb-70">
    <app-pricing></app-pricing>
</section>




<!-- section class="overview-area ptb-100">
    <app-overview></app-overview>
</section -->

<app-app-screenshots></app-app-screenshots>



<section class="faq-area ptb-100">
    <app-faq></app-faq>
</section>



<!--app-app-download></app-app-download-->

<!--section id="blog" class="blog-area pt-100 pb-70">
    <app-blog></app-blog>
</section-->

<section id="kontakt" class="contact-area ptb-100">
    <app-contact></app-contact>
</section>

<app-subscribe></app-subscribe>
